import { axios } from '@/utils/request'

const api = {
  blacklistconfList: `/blacklistconf/list`,
  blacklistconfAdd: `/blacklistconf/add`,
  blacklistconfEdit: `/blacklistconf/edit`
}

// 查询黑名单配置列表
export function blacklistconfList (params) {
  return axios({
    url: api.blacklistconfList,
    method: 'get',
    params,
    func:'查询黑名单配置列表'
  })
}

// 新增配置
export function blacklistconfAdd (data) {
  return axios({
    url: api.blacklistconfAdd,
    method: 'post',
    data,
    func:'新增配置'
  })
}

// 编辑
export function blacklistconfEdit (data) {
  return axios({
    url: api.blacklistconfEdit,
    method: 'post',
    data,
    func:'编辑'
  })
}
